import React, { useState, useMemo, useEffect, useCallback } from 'react';
import { format } from 'date-fns';
import { useParams } from 'react-router-dom';
import { ptBR } from 'date-fns/locale';
import { Container, Box, Button } from '@material-ui/core/';

import { isValid } from 'date-fns/esm';
import { LatLng, LatLngTuple } from 'leaflet';
import TableRegister from '../../components/TableRegister';
import MapMarker from '../../components/MapMarker';
import { useStyles } from './style';
import {
  Intervencao,
  Solicitacao,
  Projeto,
  Execucao,
  Envolvidos,
  Analysis,
  EngineeringResponse,
} from '../../@types/engineeringTypes';
import { fetchEngineeringById } from '../../actions/engineeringActions';

interface ParamsType {
  pathId: string;
}

const RegisterEngineering: React.FC = () => {
  const styles = useStyles();

  const { pathId } = useParams<ParamsType>();

  const [active, setActive] = useState<number>(0);
  const [variant, setVariant] = useState<'text' | 'outlined' | 'contained' | undefined>(
    'text',
  );

  const [intervencao, setIntervencao] = useState<Intervencao>({
    Tipo: '',
    Especificação: '',
    Elemento: '',
    _localId: '',
  });
  const [solicitacao, setSolicitacao] = useState<Solicitacao>({
    'Nome da Intervenção': '',
    'Data de Solicitação': '',
    'Nome do Solicitante': '',
    'Número do Protocolo': '',
    _localId: '',
    'Protocolo Informado': "Não",
    'Descrição da Intervenção': '',
  });
  const [projeto, setProjeto] = useState<Projeto>({
    'Projeto com mais de uma Intervenção': "Não",
    Deferido: '',
    Status: '',
    'Projeto Dependente': "Não",
    'Identificador do Projeto Dependente': '',
    'Identificador do Projeto': '',
    'Data de Elaboração do Projeto': '',
    Responsável: '',
    _localId: '',
  });
  const [execucao, setExecucao] = useState<Execucao>({
    'Sem GEENG': "Não",
    'Data de Conclusão': '',
    'Data de Envio': '',
    'Sem Projeto': "Não",
    'Identificador da Execução da Intervenção': '',
    'Data de Desativação': '',
    _localId: '',
    'Nome do Responsável pela Execução': '',
    'Data de Início': '',
  });
  const [envolvido, setEnvolvido] = useState<Envolvidos>({
    'Data Dois Depois': '',
    'Data Dois Antes': '',
    'Data Um Antes': '',
    'Data Um Depois': '',
    _localId: '',
  });
  const [analise, setAnalise] = useState<Analysis>({

      'Data de Analise': "",
      'Nome do Analista': "",
      'Detalhes da Analise': "",
    });

  const [register, setRegister] = useState<EngineeringResponse>({
    uuid: '',
    city: '',
    created_by: '',
    qtdAcidentesAntes: 0,
    qtdAcidentesDepois: 0,
    occurred_from: '',
    occurred_to: '',
    location_text: '',
    schema: '',
    data: {
      driverEngineeringIntervention: intervencao,
      driverEngineeringInterventionRequest: solicitacao,
      driverEngineeringInterventionProject: projeto,
      driverEngineeringInterventionExecution: execucao,
      driverEngineeringInterventionInvolved: envolvido,
      driverEnginneringAnalysis: analise,
    },
    geom: {
      coordinates: [],
    },
    neighborhood: '',
    road: '',
    state: '',
  });

  const loadRegister = useCallback(
    // eslint-disable-next-line no-shadow
    async (id: string) => {
      const registers = await fetchEngineeringById(id);

      setRegister(registers.data);
    },
    [],
  );

  function formatLine(data: Array<LatLngTuple>) {
    const latlgns: Array<LatLng> = [];

    data.forEach((content) => {
      latlgns.push(new LatLng(content[0], content[1]));
    });

    return latlgns;
  }

  function formatPoint(data: LatLngTuple | Array<LatLngTuple>) {
    if (typeof data[0] === 'number' && typeof data[1] === 'number')
      return new LatLng(data[1], data[0]);
    return new LatLng(0, 0);
  }

  useEffect(() => {
    loadRegister(pathId);
  }, [pathId, loadRegister]);

  const toDate = (date: string): String => {
    if (isValid(new Date(date))) {
      const newDate = format(new Date(date), 'dd MMMM, yyyy, HH:mm:ss', {
        locale: ptBR,
      });
      return newDate;
    }
    return '';
  };

  return (
    <Container className={styles.container}>
      <Box className={styles.box}>
        <Button
          variant={variant}
          className={`${styles.buttons} ${active === 0 ? styles.buttonActive : ''}`}
          onClick={() => {
            setActive(0);
          }}
        >
          Detalhes da Engenharia
        </Button>
      </Box>
      <>
        <Container className={styles.root}>
          <TableRegister
            title={['tipo da intervenção', 'especificação']}
            data={[
              {
                details: [
                  register.data.driverEngineeringIntervention.Tipo,
                  register.data.driverEngineeringIntervention?.Especificação,
                ],
              },
            ]}
          />
          <TableRegister
            title={['descrição da intervenção']}
            data={[
              {
                details: [
                  register.data.driverEngineeringInterventionRequest?.[
                    'Descrição da Intervenção'
                  ],
                ],
              },
            ]}
          />
          <Container className={styles.containerMap}>
            {register.data.driverEngineeringIntervention.Elemento === 'Linha' ? (
              <MapMarker location={formatLine(register.geom.coordinates)} notDragabble />
            ) : (
              <MapMarker
                drawPoint={formatPoint(register.geom.coordinates)}
                notDragabble
              />
            )}
          </Container>

          {register.data.driverEngineeringIntervention.Elemento === 'Linha' ? (
            register.geom.coordinates.map((tuple:any, index:any) => (
              <TableRegister
                title={[`latitude ${index + 1}`, `longitude ${index + 1}`]}
                data={[
                  {
                    details: [`${tuple[0]}`, `${tuple[1]}`],
                  },
                ]}
              />
            ))
          ) : (
            <TableRegister
              title={[`latitude`, `longitude`]}
              data={[
                {
                  details: [
                    `${register.geom.coordinates[1]}`,
                    `${register.geom.coordinates[0]}`,
                  ],
                },
              ]}
            />
          )}

          <TableRegister
            title={['data da solicitação', 'solicitante']}
            data={[
              {
                details: [
                  `${toDate(
                    register.data.driverEngineeringInterventionRequest?.[
                      'Data de Solicitação'
                    ] ?? "Não Informado",
                  )}`,
                  `${register.data.driverEngineeringInterventionRequest?.['Nome do Solicitante']}`,
                ],
              },
            ]}
          />

          <TableRegister
            title={['solicitação sem protocolo', 'número do protocolo']}
            data={[
              {
                details: [
                  `${register.data.driverEngineeringInterventionRequest?.['Protocolo Informado']}`,
                  `${register.data.driverEngineeringInterventionRequest?.['Número do Protocolo']}`,
                ],
              },
            ]}
          />

          <TableRegister
            title={['projeto deferido', 'identificador do projeto']}
            data={[
              {
                details: [
                  `${register.data.driverEngineeringInterventionProject?.Deferido}`,
                  `${register.data.driverEngineeringInterventionProject?.['Identificador do Projeto']}`,
                ],
              },
            ]}
          />

          <TableRegister
            title={['data de elaboração do projeto', 'responsável pelo projeto']}
            data={[
              {
                details: [
                  `${toDate(
                    register.data.driverEngineeringInterventionProject?.[
                      'Data de Elaboração do Projeto'
                    ] ?? "Não Informado",
                  )}`,
                  `${register.data.driverEngineeringInterventionProject?.Responsável}`,
                ],
              },
            ]}
          />

          <TableRegister
            title={['projeto com mais de uma intervenção', 'projeto dependente?']}
            data={[
              {
                details: [
                  `${register.data.driverEngineeringInterventionProject?.['Projeto com mais de uma Intervenção']}`,
                  `${register.data.driverEngineeringInterventionProject?.['Projeto Dependente']}`,
                ],
              },
            ]}
          />
          <TableRegister
            title={['status do projeto', 'projeto dependente']}
            data={[
              {
                details: [
                  `${register.data.driverEngineeringInterventionProject?.Status}`,
                  `${register.data.driverEngineeringInterventionProject?.['Identificador do Projeto Dependente']}`,
                ],
              },
            ]}
          />

          <TableRegister
            title={[
              'data de envio para execução',
              'execução sem projeto',
              'projeto sem número geeng',
            ]}
            data={[
              {
                details: [
                  `${toDate(
                    register.data.driverEngineeringInterventionExecution?.[
                      'Data de Envio'
                    ] ?? "Não informado",
                  )}`,
                  `${register.data.driverEngineeringInterventionExecution?.['Sem Projeto']}`,
                  `${register.data.driverEngineeringInterventionExecution?.['Sem GEENG']}`,
                ],
              },
            ]}
          />

          <TableRegister
            title={['data de início para execução', 'responsável pela execução']}
            data={[
              {
                details: [
                  `${toDate(
                    register.data.driverEngineeringInterventionExecution?.[
                      'Data de Início'
                    ] ?? "Não informado",
                  )}`,
                  `${register.data.driverEngineeringInterventionExecution?.['Nome do Responsável pela Execução']}`,
                ],
              },
            ]}
          />

          <TableRegister
            title={['data de conclusão/inauguração', 'data de desativação']}
            data={[
              {
                details: [
                  `${toDate(
                    register.data.driverEngineeringInterventionExecution?.[
                      'Data de Conclusão'
                    ] ?? "Não informado",
                  )}`,
                  `${
                    toDate(
                    register.data.driverEngineeringInterventionExecution?.[
                      'Data de Desativação'
                    ] ?? "Não informado",
                  )}`,
                ],
              },
            ]}
          />

          <TableRegister
            title={['quantidade de acidentes antes', 'quantidade de acidentes depois']}
            data={[
              {
                details: [
                  `${register.data.driverEngineeringInterventionInvolved?.bufferAntes}`,
                  `${register.data.driverEngineeringInterventionInvolved?.bufferDepois}`,
                ],
              },
            ]}
          />
        </Container>

        <Container className={styles.small}>
          <TableRegister title={['nome da intervenção']} />
          <TableRegister
            data={[
              {
                details: [
                  register.data.driverEngineeringInterventionRequest?.[
                    'Nome da Intervenção'
                  ] ?? "Não Informado",
                ],
              },
            ]}
          />
          <TableRegister title={['descrição da intervenção']} />
          <TableRegister
            data={[
              {
                details: [
                  register.data.driverEngineeringInterventionRequest?.[
                    'Descrição da Intervenção'
                  ],
                ],
              },
            ]}
          />
          <TableRegister title={['tipo da internveção']} />
          <TableRegister
            data={[
              {
                details: [register.data.driverEngineeringIntervention?.Tipo],
              },
            ]}
          />
          <TableRegister title={['descrição do tipo da internvenção']} />
          <TableRegister
            data={[
              {
                details: [register.data.driverEngineeringIntervention?.Especificação],
              },
            ]}
          />
          <Container className={styles.containerMap}>
            <MapMarker />
          </Container>
          <TableRegister title={['latitude']} />
          <TableRegister
            data={[
              {
                details: [`${register.geom.coordinates[0]}`],
              },
            ]}
          />
          <TableRegister title={['longitude']} />
          <TableRegister
            data={[
              {
                details: [`${register.geom.coordinates[0]}`],
              },
            ]}
          />
          <TableRegister title={['data da solicitação']} />
          <TableRegister
            data={[
              {
                details: [
                  `${toDate(
                    register.data.driverEngineeringInterventionRequest?.[
                      'Data de Solicitação'
                    ] ?? "Não Informado",
                  )}`,
                ],
              },
            ]}
          />
          <TableRegister title={['solicitante']} />
          <TableRegister
            data={[
              {
                details: [
                  `${register.data.driverEngineeringInterventionRequest?.['Nome do Solicitante']}`,
                ],
              },
            ]}
          />
          <TableRegister title={['solicitação sem protocolo']} />
          <TableRegister
            data={[
              {
                details: [
                  `${register.data.driverEngineeringInterventionRequest?.['Protocolo Informado']}`,
                ],
              },
            ]}
          />
          <TableRegister title={['número do protocolo']} />
          <TableRegister
            data={[
              {
                details: [
                  `${register.data.driverEngineeringInterventionRequest?.['Número do Protocolo']}`,
                ],
              },
            ]}
          />
          <TableRegister title={['projeto deferido']} />
          <TableRegister
            data={[
              {
                details: [
                  `${register.data.driverEngineeringInterventionProject?.Deferido}`,
                ],
              },
            ]}
          />
          <TableRegister title={['identificador do projeto']} />
          <TableRegister
            data={[
              {
                details: [
                  `${register.data.driverEngineeringInterventionProject?.['Identificador do Projeto']}`,
                ],
              },
            ]}
          />
          <TableRegister title={['data de elaboração do projeto']} />
          <TableRegister
            data={[
              {
                details: [
                  `${toDate(
                    register.data.driverEngineeringInterventionProject?.[
                      'Data de Elaboração do Projeto'
                    ] ?? "Não Informado",
                  )}`,
                ],
              },
            ]}
          />
          <TableRegister title={['responsável pelo projeto']} />
          <TableRegister
            data={[
              {
                details: [
                  `${register.data.driverEngineeringInterventionProject?.Responsável}`,
                ],
              },
            ]}
          />
          <TableRegister title={['projeto com mais de uma intervenção']} />
          <TableRegister
            data={[
              {
                details: [
                  `${register.data.driverEngineeringInterventionProject?.['Projeto com mais de uma Intervenção']}`,
                ],
              },
            ]}
          />
          <TableRegister title={['projeto dependente?']} />
          <TableRegister
            data={[
              {
                details: [
                  `${register.data.driverEngineeringInterventionProject?.['Projeto Dependente']}`,
                ],
              },
            ]}
          />
          <TableRegister title={['status do projeto']} />
          <TableRegister
            data={[
              {
                details: [
                  `${register.data.driverEngineeringInterventionProject?.Status}`,
                ],
              },
            ]}
          />
          <TableRegister title={['projeto dependente']} />
          <TableRegister
            data={[
              {
                details: [
                  `${register.data.driverEngineeringInterventionProject?.['Identificador do Projeto Dependente']}`,
                ],
              },
            ]}
          />
          <TableRegister title={['data de envio para execução']} />
          <TableRegister
            data={[
              {
                details: [
                  `${toDate(
                    register.data.driverEngineeringInterventionExecution?.[
                      'Data de Envio'
                    ] ?? "Não Informado",
                  )}`,
                ],
              },
            ]}
          />
          <TableRegister title={['execução sem projeto']} />
          <TableRegister
            data={[
              {
                details: [
                  `${register.data.driverEngineeringInterventionExecution?.['Sem Projeto']}`,
                ],
              },
            ]}
          />
          <TableRegister title={['projeto sem número geeng']} />
          <TableRegister
            data={[
              {
                details: [
                  `${register.data.driverEngineeringInterventionExecution?.['Sem GEENG']}`,
                ],
              },
            ]}
          />
          <TableRegister title={['data de início para execução']} />
          <TableRegister
            data={[
              {
                details: [
                  `${toDate(
                    register.data.driverEngineeringInterventionExecution?.[
                      'Data de Início'
                    ] ?? "Não Informado",
                  )}`,
                ],
              },
            ]}
          />
          <TableRegister title={['responsável pela execução']} />
          <TableRegister
            data={[
              {
                details: [
                  `${register.data.driverEngineeringInterventionExecution?.['Nome do Responsável pela Execução']}`,
                ],
              },
            ]}
          />

          <TableRegister title={['data de conclusão/inauguração']} />
          <TableRegister
            data={[
              {
                details: [
                  `${toDate(
                    register.data.driverEngineeringInterventionExecution?.[
                      'Data de Conclusão'
                    ] ?? "Não Informado",
                  )}`,
                ],
              },
            ]}
          />
          <TableRegister title={['data de desativação']} />
          <TableRegister
            data={[
              {
                details: [
                  `${toDate(
                    register.data.driverEngineeringInterventionExecution?.[
                      'Data de Desativação'
                    ] ?? "Não Informado",
                  )}`,
                ],
              },
            ]}
          />
          <TableRegister title={['quantidade de acidentes antes']} />
          <TableRegister
            data={[
              {
                details: [
                  `${register.data.driverEngineeringInterventionInvolved?.bufferAntes}`,
                ],
              },
            ]}
          />
          <TableRegister title={['quantidade de acidentes depois']} />
          <TableRegister
            data={[
              {
                details: [
                  `${register.data.driverEngineeringInterventionInvolved?.bufferDepois}`,
                ],
              },
            ]}
          />
        </Container>
      </>
    </Container>
  );
};

export default RegisterEngineering;